<template>
  <section class="favorite-list">
    <h3 class="block-title--small">{{title}}</h3>
    <ul :class="type" class="owl-carousel carousel-list reviews-carousel i-car-list   i-car-list--no-margin"  v-if="items.length > 0">
      <li v-for="(item, index) in items">
        <a :href="'/novostroyki/' + item.slug" class="list-item list-item--shadow">
            <figure class="list-item__preview">
              <img :src="item.preview" v-if="item.preview">
              <img src="/assets/common/images/no-image-icon.jpg" v-else>
            </figure>
            <section class="list-item__content list-item__content--small">
            <h4 class="list-item__title list-item__title--small-bold" v-if="type==='buildings'">
              ЖК «{{item.name}}»
            </h4>
              <h4 class="list-item__title list-item__title--small-bold" v-else>
                {{item.name}}
              </h4> <h4></h4>
            <div class="list-item__district list-item__district--no-bg" v-if="item.district">
              {{item.district.name}}
            </div>
              <button class="favorite-list__close-btn" @click.prevent="deleteItem(item.id,index)">
                <svg viewBox="0 0 10 10">
                  <use xlink:href="/assets/site/images/sprites.svg#sprite-close"></use>
                </svg>
              </button>
          </section>
        </a>

      </li>
    </ul>
    <div class="mb-5" v-else>{{message}}</div>
  </section>
</template>
<script>
import { bus } from './bus.js'
export default {
  props:['items', 'type'],
  data() {
    return {
      title:'',
      message:'',
    }
  },
  methods: {
    deleteItem(id,index) {
      axios.post('/api/favorite/delete',{type:this.type, id:id})
        .then((response) => {
          console.log(response.data)
          bus.$emit('add-favorite',false);
          this.items.splice(index, 1)
        })
    },
    toggleType() {
      if(this.type==='buildings') {
        this.title = 'Новостройки';
        this.message = 'Здесь пока нет новостроек.';
      }
      if(this.type==='flats') {
        this.title = 'Квартиры';
        this.message = 'Здесь пока нет квартир.';
      }
    },
    destroyOwlCarousel:function(classname) {
      $(classname).owlCarousel('destroy');
    },
    installOwlCarousel: function(className){

      $(className).owlCarousel({
        dots:false,
        nav:true,
        margin:30,
        navText:['<svg viewBox="0 0 14 28" >\n' +
        '<use xlink:href="/assets/site/images/sprites.svg#sprite-car-left"></use>\n' +
        '</svg>',
          '<svg viewBox="0 0 14 28" >\n' +
          '<use xlink:href="/assets/site/images/sprites.svg#sprite-car-right"></use>\n' +
          '</svg>'
        ],

        responsive:{
          0:{
            items:2,

          },
          768:{

            items:3,

          },
          1024:{
            items:4,

          },
          1200:{
            items:6,

          }
        },
      });
    },
  },
  mounted() {
    var className = '.' + this.type;
    console.log(className);
    this.toggleType();
    this.installOwlCarousel(className);
  }
}
</script>